import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=0bc3436a&scoped=true&"
import script from "./EditIcon.vue?vue&type=script&lang=js&"
export * from "./EditIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc3436a",
  null
  
)

export default component.exports